export const blogPosts = [
  {
    slug: 'the-art-of-slowing-down',
    title: 'The Art of Slowing Down',
    category: 'Presence',
    readTime: '6 min read',
    date: 'May 2026',
    image: '/images/18.webp',
    excerpt: 'We move so quickly through our days that we forget to arrive in them. Slowness is not laziness — it is the doorway back to yourself.',
    featured: true,
    content: [
      'We move so quickly through our days that we forget to arrive in them. The morning coffee becomes a task. The walk to the car becomes a transition. The conversation with a loved one becomes a pause between notifications.',
      'Slowness is not laziness. It is a radical act of presence in a world that profits from your distraction. When you slow down, you begin to notice — the way light falls across the kitchen table, the sound of your own breath, the quiet ache you have been outrunning.',
      'Begin small. Choose one moment each day and give it your full attention. Drink your tea without your phone. Watch the trees move outside your window. Let yourself feel what rises when nothing is filling the silence.',
      'What rises may surprise you. Sometimes grief. Sometimes gratitude. Often, simply relief — the relief of finally being where you are.',
      'The art of slowing down is not about doing less. It is about being more. More present. More alive. More you.',
    ],
  },
  {
    slug: 'when-you-no-longer-recognise-yourself',
    title: 'When You No Longer Recognise Yourself',
    category: 'Identity',
    readTime: '8 min read',
    date: 'April 2026',
    image: '/images/16.webp',
    excerpt: 'There is a particular kind of grief in looking in the mirror and seeing a stranger. It is also the beginning of coming home.',
    content: [
      'There is a particular kind of grief that no one prepares you for — the grief of looking in the mirror and seeing a stranger. You did everything right. You built the career, held the family together, showed up for everyone. And somewhere along the way, you disappeared.',
      'This is not failure. This is what happens when we spend decades being everything for everyone. The self does not vanish — it goes quiet, waiting patiently beneath the roles and responsibilities.',
      'The invitation is not to become someone new. It is to remember who you were before the world told you who to be.',
      'Start by listening. What did you love before it became impractical? What made you lose track of time? What truth have you been swallowing to keep the peace?',
      'The stranger in the mirror is not a stranger at all. She is you — waiting to be welcomed home.',
    ],
  },
  {
    slug: 'presence-is-not-a-destination',
    title: 'Presence Is Not a Destination',
    category: 'Stillness',
    readTime: '5 min read',
    date: 'March 2026',
    image: '/images/14.webp',
    excerpt: 'You cannot arrive at presence. You can only return to it — again and again, one breath at a time.',
    content: [
      'We treat presence like a place we might one day reach — after the deadline, after the kids grow up, after things calm down. But presence is not a destination. It is a return.',
      'Every time you notice your mind has wandered, you have a choice. You can judge yourself for leaving, or you can simply come back. The coming back is the practice. The coming back is everything.',
      'The mind will always wander. That is its nature. Your work is not to silence it, but to build a home worth returning to — a body you inhabit, a breath you trust, a moment you allow yourself to feel.',
      'Presence is available in the middle of the chaos. In the school run. In the difficult meeting. In the sleepless night. It asks only one thing: that you stop leaving yourself.',
    ],
  },
  {
    slug: 'the-courage-to-begin-again',
    title: 'The Courage to Begin Again',
    category: 'Courage',
    readTime: '7 min read',
    date: 'February 2026',
    image: '/images/15.webp',
    excerpt: 'Beginning again is not starting over. It is starting from wisdom — carrying everything you have learned into everything you are becoming.',
    content: [
      'There is a myth about starting over — that it erases what came before. That choosing a new path means admitting the old one was a mistake. This myth keeps so many of us frozen in lives that no longer fit.',
      'Beginning again is not starting over. It is starting from wisdom. Every year you have lived, every role you have carried, every loss you have survived — it all comes with you. Nothing is wasted.',
      'The courage to begin again is quieter than we expect. It rarely looks like leaping. More often it looks like one honest conversation. One boundary held. One morning where you choose yourself first.',
      'You are not too old. It is not too late. The life that is waiting for you does not need you to be fearless — it only needs you to be willing.',
      'Begin where you are. Begin small. But begin.',
    ],
  },
];
